import { useWindowDimensions } from "react-native";
import {
  MOBILE_BREAKPOINT,
  DESKTOP_BREAKPOINT,
  SMALL_SCREEN_BREAKPOINT,
} from "../constants/breakpoints";

export const useViewport = () => {
  const { width, height } = useWindowDimensions();

  return {
    width,
    height,
    isMobile: width < MOBILE_BREAKPOINT,
    isDesktop: width >= DESKTOP_BREAKPOINT,
    isSmallScreen: width < SMALL_SCREEN_BREAKPOINT,
  };
};
